import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import HomeCarouselItem from './HomeCarouselItem';

import './css/Carousel.css';
import { useMediaQuery } from 'react-responsive';
const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 960 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 960, min: 464 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

  const desc1 = `Kate the Chemist is back with a bang to share her new book "It's Elemental: The Hidden Chemistry in Everything". Kate uses the science behind opening a soda bottle to teach Kelly and "Never Have I Ever" actor Jaren Lewison how to make a huge explosion with ping pong balls on set.`

function LiveTVCarousel() {
    // return false;

    const isMobile = useMediaQuery({ query: `(max-width: 960px)` });

    return (
        <div className={isMobile ? "carousel-main-mobile" : "carousel-main"}>
            <Carousel
            swipeable={false}
            draggable={false}
            showDots={false}
            responsive={responsive}
            ssr={false} // means to render carousel on server-side.
            infinite={true}
            // autoPlay={this.props.deviceType !== "mobile" ? true : false}
            autoPlay={true}
            autoPlaySpeed={6000}
            keyBoardControl={true}
            // customTransition="all .5"
            transitionDuration={1000}
            containerclassName="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            // deviceType={this.props.deviceType}
            dotListclassName="custom-dot-list-style"
            itemclassName="carousel-item-padding-40-px"
            sliderclassName="carousel-slider"
            renderDotsOutside
            >

                <HomeCarouselItem 
                    videoUrl="S1oUd43yIQM"
                    description="Kate the Chemist joins the show to teach us some new and exciting scientific experiments. But, watch out in the front row!" 
                />

                <HomeCarouselItem 
                    videoUrl="0N59POGJ84I"
                    description="Chemist Kate Biberdorf, also known as Kate the Chemist, demonstrates fun science experiments to get kids excited to learn in the upcoming school year." 
                />

                <HomeCarouselItem 
                    videoUrl="gFRaWN_w4jw"
                    description="Kate Biberdorf, known as Kate the Chemist joins TODAY to share easy and fun back-to-school science experiments to try at home or school including making string slime and 'hatching dinosaur eggs.'
                    " 
                />

                

                <HomeCarouselItem 
                    videoUrl="JShogDXSDMI"
                    description="Kate the Chemist and Rach create a spooky foaming pumpkin patch and make color-changing magic in a fish tank with dry ice. Do not try this at home." 
                />

                <HomeCarouselItem 
                    videoUrl="nELtaMKMP8o"
                    description="Scientist and self-proclaimed pyromaniac Kate the Chemist turns Stephen into America's only fire-breathing late night host." 
                />

            <HomeCarouselItem 
                    videoUrl="9m0xY3Yp3dI"
                    description={desc1}
                />

                <HomeCarouselItem 
                    videoUrl="WuZ7UrPdTm4"
                    description="Grab those lab coats! Author of 'Kate the Chemist: The Big Book of Experiments' Kate Biberdorf drops by to show Kelly and Los Angeles County Teacher of The Year Rhiannon Chavez a science experiment that is fun for kids whether they're at home or in the classroom.
                    " 
                />


                
            </Carousel>
        </div>
    );
}

export default LiveTVCarousel;
